export const TELEFONKA_SHOWCASE_INSTAGRAM_URL =
  "https://www.instagram.com/p/Db29yIpoBIY/";

export const TELEFONKA_SHOWCASE_COPY = {
  hu: {
    kicker: "Nézd meg működés közben",
    title: "Így kel életre a Telefonka",
    body:
      "Nézd meg, hogyan használják a vendégek a Telefonkát, és milyen egyszerűen születnek belőle személyes, megismételhetetlen emlékek.",
    aria: "A Telefonka működését bemutató videó",
  },
  en: {
    kicker: "See it in action",
    title: "See Telefonka come to life",
    body:
      "See how guests use Telefonka and how effortlessly personal, one-of-a-kind memories come to life.",
    aria: "Video showing Telefonka in use",
  },
};
